import { Pressable } from 'react-native';
import styled from 'styled-components/native';

export const PressableWrapper = styled(Pressable)`
    flex: 1;
    align-items: center;
    height: 48px;
    justify-content: center;
`;
